import React from 'react'
import cn from 'classnames'
import { Element } from 'react-scroll'
import { SwiperSlide } from 'swiper/react'

import { Box } from '@features/story/components/Box'
import { CharacterCard } from '@components/CharacterCard'
import { SocialSharing } from '@components/SocialSharing'
import CoinButton from '@components/CoinButton'
import { BASE_URL } from '@configs/config'
import { Swiper } from '@features/home/components/CustomSwiper'
import { CharacterProps } from './interface'

export const Character = ({
  className,
  bookId,
  bookName,
  characters,
  isDrawer = false,
  handleSupportCharacter,
}: CharacterProps) => {
  return (
    <Box
      className={cn(
        'bg-gray-4 dark:bg-dark-12 desktop:m-[10px_0_20px_0] rounded-none relative',
        className
      )}
    >
      <div
        className={cn(
          'bg-character dark:bg-character-dark bg-no-repeat bg-cover bg-top absolute h-[358px] w-full left-0 top-0'
        )}
      />
      <div className='relative max-w-[1166px] mx-auto'>
        <Box.Title className='text-2xl p-[30px_0_0_30px] mobile:p-[20px_0_0_20px] dark:text-white-2'>
          ตัวละคร
        </Box.Title>

        <div
          className={cn({
            'pl-[46px] pr-[36px] tablet-mobile:pl-0 tablet-mobile:pr-0':
              isDrawer,
          })}
        >
          <Swiper
            slidesPerView='auto'
            isShowNavigation
            prevclass='left-[-46px] tablet:hidden'
            nextclass='right-[-35px] tablet:hidden'
          >
            {characters.map(item => {
              return (
                <SwiperSlide
                  className='ml-[20px] mt-[20px] mb-[30px] desktop:mr-[10px]'
                  key={item.id}
                >
                  <Element name={`character-${item.id}`}>
                    <CharacterCard
                      className={cn('h-full', {
                        'w-[200px] mobile:w-[260px]': isDrawer,
                        'w-[260px]': !isDrawer,
                      })}
                      id={String(item.id)}
                      bookId={bookId}
                      bookName={bookName}
                      imageUrl={item.resizeImgPath || item.imgPath}
                      rank={item.characterRank.name}
                      nextRank={item.characterNextRank?.name}
                      story={item.description}
                      name={item.name}
                      characterRole={item.characterRole.name}
                      coin={item.coinsTotal}
                      coinLeft={item.coinsToNextLevel}
                      characterRankStartCoins={item.characterRank.startCoins}
                      characterRankImg={item.characterRank.imgPath}
                      size={isDrawer ? 's' : 'm'}
                    >
                      <>
                        <hr
                          className={cn('text-gray-3', {
                            'my-[10px]': !isDrawer,
                          })}
                        />
                        <div className='grid grid-cols-[1fr_30px] items-center gap-x-[10px]'>
                          <CoinButton
                            type='button'
                            disabled={!item.donatable}
                            className='w-full'
                            secondClassName='text-[16px] h-[30px]'
                            onClick={() => handleSupportCharacter(item)}
                            data-test='donate-character'
                            size={30}
                          >
                            สนับสนุน
                          </CoinButton>
                          <SocialSharing
                            shareUrl={`${BASE_URL}/share?characterId=${item.id}&bookId=${bookId}`}
                            bookId={bookId}
                          />
                        </div>
                      </>
                    </CharacterCard>
                  </Element>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </Box>
  )
}
